/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_76a0aad7"]'><cube-icon :type="(type)"/></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_76a0aad7"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_76a0aad7"}
  /** script content **/
  require("./icon-example.mpx.js?isComponent&outputPath=components%2Ficon-example76a0aad7%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./icon-example.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ficon-example76a0aad7%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_76a0aad7"],
    ctorType: "component",
    outputPath: "components/icon-example76a0aad7/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-icon':getComponent(require("../../../packages/mpx-cube-ui/src/components/icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>